var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/ban"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73 3.78719L12.2141 11.2713C13.8424 9.17902 13.695 6.15257 11.7719 4.22941C9.84874 2.30626 6.82228 2.15886 4.73 3.78719ZM11.2713 12.2141L3.78719 4.73C2.15886 6.82228 2.30626 9.84874 4.22941 11.7719C6.15257 13.695 9.17902 13.8424 11.2713 12.2141ZM3.28661 3.28661C5.8901 0.683111 10.1112 0.683111 12.7147 3.28661C15.3182 5.8901 15.3182 10.1112 12.7147 12.7147C10.1112 15.3182 5.8901 15.3182 3.28661 12.7147C0.683111 10.1112 0.683111 5.8901 3.28661 3.28661Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBan);
export default __webpack_public_path__ + "static/media/ban.4590c321dc0cbacf964e9399178931eb.svg";
export { ForwardRef as ReactComponent };